<form [formGroup]="formGroup">
	<div class="file-upload-wrapper">
		<div
			class="form-control upload-container"
			[class.dragging]="isDragging"
			(dragover)="preventDefaults($event); isDragging = true"
			(dragleave)="isDragging = false"
			(drop)="onDrop($event)"
			(click)="fileInput.click()"
			(keydown.enter)="fileInput.click()"
			tabindex="0"
		>
			<i class="bi bi-upload"></i>
			<span *ngIf="files.length === 0">Drag & Drop files here or click to upload</span>
			<span *ngIf="files.length > 0"
				>{{ files.length }} file{{ files.length === 1 ? '' : 's' }} selected. Click to add more files.</span
			>
		</div>

		<input type="file" #fileInput [multiple]="multiple" [accept]="allowedTypes.join(',')" (change)="onFileSelected($event)" hidden />

		<ng-container *ngIf="isNative">
			<button type="button" class="btn btn-sm btn-primary" (click)="openCamera()" [disabled]="disabled">
				<i class="bi bi-camera"></i> Open Camera
			</button>
		</ng-container>

		<ul class="file-list" *ngIf="files.length">
			<li *ngFor="let file of files; let i = index" class="file-item">
				<i class="bi bi-file-earmark"></i> {{ file.name }}
				<button type="button" class="btn-close" aria-label="Close" (click)="removeFile(i)"></button>
			</li>
		</ul>

		<div *ngIf="control.invalid && control.errors" class="invalid-feedback">
			<p *ngIf="control.errors?.required">File is required.</p>
			<p *ngIf="control.errors?.custom">{{ control.errors.custom }}</p>
		</div>
	</div>
</form>
